<template>
  <section class="ws-advanced-search">
    <ws-filter-item
      id="k"
      :type="filterType.SEARCH"
      :label="$t('Наименование ЦПДЭ')"
      @ready="onFilterReady"
      @change="onFilter">
    </ws-filter-item>
    <header class="ws-advanced-search__header" @click="isOpen = !isOpen">
      <h3 class="ws-advanced-search__title has-text-primary is-size-2" v-text="title"></h3>
      <div class="ws-advanced-search__actions">
        <button class="ws-button button is-text"
                :aria-controls="id">
          <ws-icon
            class="ws-button__icon"
            name="arrow-thin"
            color="#000000"
            :class="{'ws-icon--left': !isOpen}"
            :fill="false"
            :title="$t('Свернуть/Развернуть')"
            width="17"
            height="11"
          />
        </button>
      </div>
    </header>
    <b-collapse
      :aria-id="id"
      class="ws-advanced-search__form"
      :open.sync="isOpen">
      <div class="columns">
        <div class="column">
          <ws-permission-node :resources="['resources/region']">
            <ws-filter-item
              id="region_guid"
              field="title.display"
              :type="filterType.REFBOOK"
              :label="$t('Регион')"
              entity="public/refbook/region"
              :params="{ country: config.default_country_code }"
              @ready="onFilterReady($event); onRegionFilterReady($event)"
              @change="onFilter($event); onRegionFilter($event)">
            </ws-filter-item>
          </ws-permission-node>
        </div>
        <div class="column">
          <ws-filter-item
            id="locality_guid"
            field="title.display"
            :type="filterType.REFBOOK"
            :label="$t('Населенный пункт')"
            :disabled="!region_guid"
            entity="public/refbook/locality"
            :params="{ country: config.default_country_code, region_guid }"
            @ready="onFilterReady"
            @change="onFilter">
          </ws-filter-item>
        </div>
        <div class="column">
          <ws-permission-node :resources="['resources/competency']">
            <ws-filter-item
              id="competency_guid"
              field="name.display"
              :type="filterType.REFBOOK"
              :label="$t('Профессия/специальность (ДЭ)')"
              entity="competence"
              resource-id="competency"
              @ready="onFilterReady"
              @change="onFilter">
            </ws-filter-item>
          </ws-permission-node>
        </div>
        <div class="column">
          <ws-filter-item
            id="accreditated"
            :type="filterType.SELECT"
            :label="$t('Статус')"
            @ready="onFilterReady"
            :options="[
              { label: $t('Не важно'), value: '' },
              { label: $t('Обследован'), value: 'true' },
              { label: $t('Не обследован'), value: 'false' }
            ]"
            @change="onFilter">
          </ws-filter-item>
        </div>
      </div>
    </b-collapse>
  </section>
</template>

<script>
import { constants } from '@/services/constants.service'
import filterMixin from '@/mixins/filter.mixin'
import WsFilterItem from '@/components/common/WsFilterItem'
import filterType from '@/components/common/data/filter-type.enum'

export default {
  name: 'WsDeCenterFilter',
  components: { WsFilterItem },
  mixins: [ filterMixin ],
  data () {
    return {
      constants,
      config: __config,
      filterType,
      region_guid: null
    }
  },
  methods: {
    onRegionFilter (filterChangeDto) {
      if (filterChangeDto.component.id === 'region_guid') {
        this.region_guid = filterChangeDto.value
      }
    },
    onRegionFilterReady (filterChangeDto) {
      if (filterChangeDto.component.id === 'region_guid') {
        this.region_guid = filterChangeDto.value
      }
    }
  }
}
</script>
